import {
  FigureView,
  BroadsiderHomeSelector
} from '../../components';
import BroadsiderThreeHudBanner from './BroadsiderThreeHudBanner';
import { StyledBroadsiderHud } from './BroadsiderHud.styled';
import { useState } from 'react';
import { FigureModel } from '../../models';
import useIsMobile from '../../hooks/useIsMobile';

const HOMESCREEN_MODELS = [ 
  {
    id: 'STAGE 01',
    name: 'MESH',
    vrm: '/assets/mesh_avatar.vrm',
    glb: '/assets/mesh_avatar.vrm',
    image: '/assets/mesh_avatar.png'
  },
  {
    id: 'STAGE 02',
    name: 'Default',
    vrm: '/assets/default_avatar.vrm',
    glb: '/assets/default_avatar.vrm',
    image: '/assets/default_avatar.png'
  },
  {
    id: 'STAGE 03',
    name: 'Full',
    vrm: '/assets/full_avatar.vrm',
    glb: '/assets/full_avatar.vrm',
    image: '/assets/full_avatar.png'
  }
];

const BroadsiderThreeHud = () => {
  const figures = HOMESCREEN_MODELS.map((f) => FigureModel.fromAlchemyNft(f));
  const [selectedBroadsider, setSelectedBroadsider] = useState(figures[0]);
  const [highlightedIndex, setHighlightedIndex] = useState(0);
  const controls = {};
  const isMobile = useIsMobile();

  const onSelectBroadsider = (figure) => {
    setSelectedBroadsider(figure);
    const index = figures.findIndex((f) => f.nftData.id === figure.nftData.id);
    if (index === 0) {
      setHighlightedIndex(0);
      controls.selectFirstAvatar();
    } else if (index === 1) {
      setHighlightedIndex(1);
      controls.selectSecondAvatar();
    } else if (index === 2) {
      setHighlightedIndex(2);
      controls.selectThirdAvatar();
    }
  };
  return (
    <StyledBroadsiderHud>
        <FigureView
	  controls={controls}
          figure={figures[0]}
          figure2={figures[1]}
          figure3={figures[2]}
	  objectPath={null}
	  weaponPath={null}
	  highlightedIndex={highlightedIndex}
	  noDecorators
          width='100%'
          height='100%'
	/>
        {isMobile ? (
            <div className='hud-mobile'>
	      <div className='hud-mobile-content'>
	        <BroadsiderHomeSelector broadsiders={figures} selectedBroadsider={selectedBroadsider} setSelectedBroadsider={onSelectBroadsider}/>
              </div>
            </div>
          ) : (<div className='hud-panel hud-panel-left hud-panel-top' style={{ left: 0, zIndex: 0 }}>
	    <BroadsiderThreeHudBanner />
	    <div style={{ paddingLeft: '8rem', paddingTop: '2rem' }}>
	      <BroadsiderHomeSelector broadsiders={figures} selectedBroadsider={selectedBroadsider} setSelectedBroadsider={onSelectBroadsider}/>
            </div>
          </div>)}
    </StyledBroadsiderHud>
  );
};

export default BroadsiderThreeHud;
